import styled from 'styled-components';

const StyledInput = styled.input.attrs({
	type: 'text',
	autoComplete: 'off',
})`
	width: 300px;
	height: 24px;
	padding: 4px 10px;
	border-radius: 4px;
	border-width: 0;
	outline: none;
	box-shadow:
		inset 0px 0px 3px rgba(0, 0, 0, 0.25),
		inset 0px 1px 3px rgba(0, 0, 0, 0.7),
		0px 1px 0px rgba(255, 255, 255, 0.03);
	font-family: 'Helvetica Neue', Arial, sans-serif;
	font-size: 13px;
	opacity: 0.7;

	&:focus {
		opacity: 1;
	}
`;

export { StyledInput };
